import { Header, SessionHeader, ConnectionHeader } from "@/components";
import { useLocation } from "react-router-dom";
function CommonLayout({
  children,
  session_id,
  guestParticipants = false,
  activeKey,
  handleShow,
  handleShowPracticeRun,
  handleAscending,
  isAscending,
  socket,
  userData,
  participants,
  participantsLoading,
  teamData,
  teamsLoading,
  sessionData,
  teamParticipants,
}) {
  const location = useLocation();

  return (
    <>
      <Header
        handleShow={handleShow}
        handleShowPracticeRun={handleShowPracticeRun}
        handleAscending={handleAscending}
        session_id={session_id}
        guestParticipants={guestParticipants}
        location={location}
        userData={userData}
        socket={socket}
      />
      {location?.pathname !== "/connection" ? (
        <SessionHeader
          guestParticipants={guestParticipants}
          isAscending={isAscending}
          activeKey={activeKey}
          handleAscending={handleAscending}
          socket={socket}
          userData={userData}
          participants={participants}
          participantsLoading={participantsLoading}
          teamData={teamData}
          teamsLoading={teamsLoading}
          sessionData={sessionData}
          teamParticipants={teamParticipants}
        />
      ) : (
        <ConnectionHeader />
      )}
      {children}
    </>
  );
}
export default CommonLayout;
